import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { isDeviceConnectionType } from '../../../../../connections/connections.utils.js';
import { ImgFolderDevice } from '@fabric-app/icons/old';
import { renderResourceIcon } from '../../../../../resource-detail/components/ResourceIcon/renderResourceIcon.js';

const ResourcePreviewListItemFolder = () => {
  const { resource } = useResourceDataContextSafe();
  return isDeviceConnectionType(resource.root?.subtype) ? /* @__PURE__ */ jsx(Image, {
    src: ImgFolderDevice,
    alt: "Device Folder",
    draggable: false
  }) : /* @__PURE__ */ jsx(Wrapper, {
    draggable: false,
    children: renderResourceIcon(resource, {
      size: 30
    })
  });
};
const Image = styled.img.withConfig({
  displayName: "ResourcePreviewListItemFolder__Image",
  componentId: "sc-1256477f-0"
})([
  `max-height:1.5rem;max-width:2rem;height:auto;width:auto;`
]);
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewListItemFolder__Wrapper",
  componentId: "sc-1256477f-1"
})([
  `display:flex;align-items:center;justify-content:center;height:1.875rem;width:1.875rem;font-size:1.5rem;`
]);

export { ResourcePreviewListItemFolder };
//# sourceMappingURL=ResourcePreviewListItemFolder.js.map
